
module library {
  'use strict';

  export class LibraryDetailCtrl {


    // $inject annotation.
    // It provides $injector with information about dependencies to be injected into constructor
    // it is better to have it close to the constructor, because the parameters must match in count and type.
    // See http://docs.angularjs.org/guide/di
    public static $inject = [
      '$scope',
      '$timeout',
      '$filter',
      '$window',
      'libraryService', 
      'anchorNavService',
      'pageMetaService',
      '$mdDialog',
      '$mdPanel',
    ];

    // dependencies are injected via AngularJS $injector
    // controller's name is registered in Application.ts and specified from ng-controller attribute in index.html
    constructor(
      private $scope : ILibraryDetailCtrlScope,
      private $timeout : ng.ITimeoutService,
      private $filter : library.IUniqueFilter,
      private $window : ng.IWindowService,
      private libraryService : ILibraryService,
      private anchorNavService : navigation.IAnchorNavService,
      private pageMetaService : navigation.IPageMetaService,
      private $mdDialog : ng.material.IDialogService,
      private $mdPanel : ng.material.IPanelService
      ) {
      
      // 'vm' stands for 'view model'. We're adding a reference to the controller to the scope
      // for its methods to be accessible from view / HTML
      $scope.vm = this;
      $scope.meta = pageMetaService.getPageMeta;
      $scope.revIdMissing = false;
      $scope.error = false;

      

      anchorNavService.subscribeOnLocationChanged($scope, (event, re) => {
        var fileSrcRevID : string = anchorNavService.getQueryValue('revid');
        if (fileSrcRevID && typeof fileSrcRevID !== 'boolean' && parseInt(fileSrcRevID) != this.$scope.data.Revision.DocumentFileSrcID) {
          this.loadDocumentDetails(parseInt(fileSrcRevID));
        }
      });


    }
    
    locals : { parentScope: ILibraryControllerScope, revId: number };


    public $onInit(): void {
      //try to get revid from query if not in locals (popup)
      if (!this.locals || !this.locals.revId) {
        var id = this.anchorNavService.getQueryValue('revid');
        if (id && typeof id !== 'boolean') {
          if (!this.locals) {
            this.locals =  { parentScope: null, revId: null};
          }
          this.locals.revId = parseInt(id);
        }
      } 
      
      this.$scope.settings = { view : "Details" };

      this.$scope.data = this.$scope.data || <any>{};

      if (this.locals && this.locals.revId) {
        this.loadDocumentDetails(this.locals.revId);
      } else {
        this.$scope.revIdMissing = true;
      }
    }

    closeDialog() {
      this.$mdDialog.hide();
    }

    public loadDocumentDetails(fileSrcRevId : number) {
      this.$scope.requestOnGoing = true;
      this.libraryService.loadDocumentDetails(this.$scope.data, fileSrcRevId).then((data) =>  {
        this.$scope.data = data;  
      }).catch((err) => {
        this.$scope.error = true;
      }).finally(() => {
        this.$scope.requestOnGoing = false;
      }); 
    }

    openProduct(ev, p) : void {
      if (ev) ev.preventDefault();
      this.$window.location.href = p.Url;
      this.$mdDialog.hide();
    }

  }

}